import Api from '@/services/Api';

export default {
  getList() {
    return Api().get('/branches');
  },
  create(params: any) {
    return Api().post('/branches', params);
  },
  import(params: any) {
    console.log(params);
    return Api(true).post('/branches/import', params.formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },
};
